module.exports = "fragment PhoneNumberCountryFragment on PhoneNumberCountry {\n  __typename\n  name\n  isoCode\n  callingCode\n}\n"